import React from "react";
import {Alert} from "@aws-amplify/ui-react";
import {useLoaderData} from "react-router-dom";

const LicenseBanner = () => {

  const {license_is_active} = useLoaderData();

  return !license_is_active &&
    (
      <Alert
        variation="warning"
        isDismissible={false}
        hasIcon={true}
        heading="Attenzione! La tua licenza è scaduta"
      >
        Contatta l'<a href="/assistenza" target="_blank" style={{color: 'var(--coaching-primary-color)'}}>Ufficio Assistenza</a>&nbsp;
        per maggiori informazioni
      </Alert>
    )
}

export default LicenseBanner;